import * as yup from 'yup';

export const singInSchema = yup.object().shape({
  email: yup.string().required('Email required').email(),
  password: yup
    .string()
    .required('Password required')
    .min(6, 'Password is too short - should be 6 chars minimum.'),
});
